<template>
  <div class="btn _fw-500" @click="goBack">
    <ArrowLeft class="_mr-2" />
    <span>{{ $t('interface.back') }}</span>
  </div>
</template>

<script>
import ArrowLeft from 'icons/ArrowLeft'

export default {
  name: 'AppBtnBreadCrumb',
  props: {
    params: Object,
    parent_page: String,
  },
  components: {
    ArrowLeft,
  },
  methods: {
    goBack() {
      const parent = this.parent_page || this.$route.meta.parent_page
      if (parent) {
        this.$router.push(
          this.helpers.buildRoute({
            name: parent,
            params: this.params,
          })
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  background-color: color(green-light);
  color: color(green-second);
  border-radius: 16px;
  width: fit-content;
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    background-color: darken(color(green-light), 10);
    color: darken(color(green-second), 10);
  }
}
</style>
